import React, { useState, useEffect } from 'react';
import close from '../../assets/design/pricing/closing-x.png';
import calendar from '../../assets/design/dashboard/calendar.png';
import './DashboardPopups.css';
import { Link, useNavigate } from 'react-router-dom';
import { isAuthed } from '../../services/auth.service';
import { getAvailableSellersAll, addUserEventTracking, addCompanyClick, createSellerDemo, getUserProfile, hasAvailableApplications, getAvailableOffers, companyOfferUse, getCompanyCampaigns, getBuyerDashboardHome } from '../../utils/api';
import { Gift, Video, Star } from 'lucide-react';
import QualifierQuestions from '../../components/qualifier/QualifierQuestions';
import AvailableTimes from '../../components/qualifier/AvailableTimes';
import SubmitTimes from '../../components/qualifier/SubmitTimes';
import FadeIn from '../../utils/fadein';
import Share from '../search/Share';
import { FaCheckCircle, FaTimes, FaCheck } from 'react-icons/fa';
import { BadgeDollarSign, Link2, PenIcon, Ticket, InfoIcon } from 'lucide-react';
import { Spinner } from '@chakra-ui/react';
import useSubscriberStatus from '../../hooks/useSubscriberStatus';
import ScrollToTop from '../../components/layout/ScrollToTop';
import { DollarSign, Award, Share2, Users, TrendingUp, AlertCircle, ChevronRight, Unlock, X } from "lucide-react";

const BuyerHome = () => {
  const navigate = useNavigate();
  const [results, setResults] = useState([]);
  const [bookingLoading, setBookingLoading] = useState(false);
  const [currentDemo, setCurrentDemo] = useState(null);
  const [currentDemoId, setCurrentDemoId] = useState(null);
  const [showQualifier, setShowQualifier] = useState(false);
  const [showAdvice, setShowAdvice] = useState(false);
  const [showMaxReached, setShowMaxReached] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [adviceType, setAdviceType] = useState(null);
  const [hasAvailable, setHasAvailable] = useState(false);
  const [showHasNoCompany, setShowHasNoCompany] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [hasCompany, setHasCompany] = useState(false);
  const [currentCompanyId, setCurrentCompanyId] = useState(null);
  const [showHasApplied, setShowHasApplied] = useState(false);
  const [showUnverified, setShowUnverified] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  const [loading, setLoading] = useState(false);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const {subscriberLoading, subscriberData} = useSubscriberStatus();
  const [campaigns, setCampaigns] = useState([]);
  const [loadedCampaigns, setLoadedCampaigns] = useState(false);

  const [activeTab, setActiveTab] = useState("overview");
  const [showBanner, setShowBanner] = useState(true);
  const [showEmailBanner, setShowEmailBanner] = useState(true);
  const [showOffersBanner, setShowOffersBanner] = useState(() => {
    return localStorage.getItem('hideOffersBanner') !== 'true'
  });
  const [showProfileDialog, setShowProfileDialog] = useState(false);
  const [showEarnPointsDialog, setShowEarnPointsDialog] = useState(false);
  
  // Placeholder data for a new user
  const [profileCompleted, setProfileCompleted] = useState(false);
  const [profileShares, setProfileShares] = useState(0);
  const [earnedPoints, setEarnedPoints] = useState(0);
  const [totalUnlockedDeals, setTotalUnlockedDeals] = useState(0);
  const [emailVerified, setEmailVerified] = useState(false);
  const [workEmailVerified, setWorkEmailVerified] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [profileLoaded, setProfileLoaded] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [loadedDashboardData, setLoadedDashboardData] = useState(false);

  // Placeholder for banner information
  const bannerInfo = {
    title: "Complete Your Profile",
    description: "Create your professional profile to unlock special offers and earn rewards from top software companies.",
    actionText: "Complete Profile",
    type: "profile" // Type helps with styling and logic
  };

  const handleShareProfile = () => {
    alert("Profile Shared: Your professional profile link has been copied to clipboard.");
    setProfileShares(prev => prev + 1);
  };

  const handleUnlockDeal = () => {
    setTotalUnlockedDeals(prev => prev + 1);
    alert("Deal Unlocked: You've successfully unlocked a new exclusive offer.");
  };

  const handleEmailVerify = () => {
    setEmailVerified(true);
    setShowEmailBanner(false);
    setEarnedPoints(75); // Add initial points as a bonus
    
    alert("Email Verified! You've unlocked the ability to earn points and received 75 bonus points!");
  };

  const handleDismissOffers = () => {
    setShowOffersBanner(false);
    localStorage.setItem('hideOffersBanner', 'true');
  };

  const imageUrl = process.env.REACT_APP_IMAGE_URL;

   async function fetchData() {
      setLoading(true); // Set loading to true before fetch
      const response = await getCompanyCampaigns();
      if (response.success) {
        setResults(response.data);
      }
      setLoading(false);
    }
    

  useEffect(() => {
    if (isAuthed()) {
      setIsLoggedIn(true);
    }

    async function loadUserProfile() {
          let res = await getUserProfile();
    
          if (res.success) {
            setProfileLoaded(true);
            setUserProfile(res.data);
            setWorkEmailVerified(res.data.work_email_verified);
           // await checkTimezone(res.data.tz);
    
          } 
        }

    async function loadDashboardData() {
      let res = await getBuyerDashboardHome();
      if (res.success) {
        setDashboardData(res.data[0]);
        setTotalUnlockedDeals(res.data[0].unlocked_deals_count);
        setLoadedDashboardData(true);
      }
    }

    loadDashboardData();
        loadUserProfile();
  }, []);
  

  useEffect(() => {
    async function fetchData() {
      setLoading(true); // Set loading to true before fetch
      const response = await getCompanyCampaigns();

      console.log('response', response);
      if (response.success) {
        setResults(response.data);
      }
      setLoading(false);
    }

    async function loadUserProfile() {
      let res = await getUserProfile();

      console.log(res.data);

      if (res.success) {
        let _user = res.data;

        if (_user.work_email_verified) {
          setIsVerified(true);
        }

        else {
          setIsVerified(false);
        }

        if (_user.company_id != null) {
          setHasCompany(true);
        }
      }
    }
    loadUserProfile();
    fetchData();
  }, []);

  function demoAccepted() {
    let _filter = results.filter(item => item.company_id !== selectedCompanyId);
    setResults(_filter);
  }

  async function handleQualifierClick(demo_id, item) {
    console.log(demo_id, item);
    setSelectedCompanyId(item.company_id);
    if (isLoggedIn === false) {
      setAdviceType('RequestDemo');
      setShowAdvice(true);
      setBookingLoading(false);
      return;
    }

    if (hasCompany === false) {
      console.log("no company info found");
      setShowHasNoCompany(true);
      return;
    }

    setBookingLoading(true);
    setSelectedCompanyId(item.company_id);
    setCurrentCompanyId(item.company_id);

    let _check = await hasAvailableApplications();

    if (_check.success) {
      if (_check.data === true) {
        setShowMaxReached(false);
        setHasAvailable(true);
      }

      else {
        setHasAvailable(false);
        setShowMaxReached(true);
        setBookingLoading(false);
        return;
      }
    }

    if (demo_id === null) {
      let data = { seller_id: item.seller_id };
      let _res = await createSellerDemo(data);

      if (_res.success) {
        setCurrentDemo(item);
        setCurrentDemoId(_res.data);
        setShowQualifier(true);
      }

      else {
        if (_res.has_applied != null && _res.has_applied === true) {
          setShowHasApplied(true);
          // alert("Looks like you have already applied to this company in the past. We only allow 1 application per company per user currently.")
        }

        else {
          setCurrentDemo(item);
          setCurrentDemoId(_res.demo_id);
          setShowQualifier(true);
        }
      }

      setBookingLoading(false);
    }

    else {
      setCurrentDemo(item);
      setCurrentDemoId(demo_id);
      setShowQualifier(true);
      setBookingLoading(false);
    }

    await addUserEventTracking('Book demo click', demo_id);
    await addCompanyClick(item.company_id, 'Discover software');
  }


  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-gray-50">

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Buyer Dashboard</h1>
            <p className="text-gray-600">
              Manage your upcoming demos, unlock exclusive deals, and earn rewards
            </p>
          </div>
          {/* <div className="flex space-x-3">
            <button 
              onClick={handleShareProfile}
              className="px-4 py-2 text-white bg-purple-600 rounded-md hover:bg-purple-700 inline-flex items-center gap-2 text-sm font-medium transition-colors"
            >
              <Share2 className="w-4 h-4" />
              Share Profile
            </button>
          </div> */}
        </div>

        {profileLoaded == true && workEmailVerified === false && (
        <div className="bg-gradient-to-r from-teal-50 to-teal-100 border border-teal-200 rounded-md shadow-sm mb-6 p-4">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center">
            <div className="bg-teal-600 rounded-full p-2 mr-4">
              <BadgeDollarSign className="text-white w-5 h-5" />
            </div>
            <div>
              <h5 className="font-medium text-base text-teal-800">Get $75 per Demo - Verify Your Work Email</h5>
              <p className="text-teal-700 text-sm">
                Earn points for each vendor demo and redeem them for gift cards or cash rewards. Verify now to unlock!
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <Link 
            to="/account/work-email"
              className="bg-teal-600 hover:bg-teal-700 text-white rounded-md text-sm px-3 py-2 h-9 font-medium transition-colors"
            >
              Verify Email
            </Link>
            <button 
              className="text-teal-700 hover:text-teal-900 hover:bg-teal-100 rounded-md w-9 h-9 flex items-center justify-center transition-colors"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
        )}

        {/* Special Offers Banner */}
        {showOffersBanner && (
          <div className="bg-gradient-to-r from-amber-50 to-amber-100 border border-amber-200 rounded-lg shadow-sm mb-6">
            <div className="flex items-center justify-between w-full p-4">
              <div className="flex items-center">
                <div className="bg-amber-600 rounded-full p-2 mr-4">
                  <Gift className="text-white w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-medium text-base text-amber-800">Exclusive Offers Available</h3>
                  <p className="text-sm text-amber-700">Unlock special deals and discounts from top enterprise software vendors.</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Link 
                to='/dashboard/all-offers'
                  className="px-3 py-2 h-9 bg-amber-600 hover:bg-amber-700 text-white rounded-md text-sm font-medium transition-colors"
                >
                  View Offers
                </Link>

                <button 
                  className="h-9 w-9 rounded-md flex items-center justify-center text-amber-700 hover:text-amber-900 hover:bg-amber-100"
                  onClick={handleDismissOffers}
                  title="Dismiss permanently"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Profile Completion Banner */}
        {showBanner && (
          <div className="bg-gradient-to-r from-blue-50 to-blue-100 border border-blue-200 rounded-lg shadow-sm mb-6">
            <div className="flex items-center justify-between w-full p-4">
              <div className="flex items-center">
                <div className="bg-blue-600 rounded-full p-2 mr-4">
                  <Users className="text-white w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-medium text-base text-blue-800">Get Paid For Your Time</h3>
                  <p className="text-sm text-blue-700">Create your LeadrPro profile and share it with solicitors via email or LinkedIn to monetize your expertise.</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Link 
                  to="/account/profile"
                  className="px-3 py-2 h-9 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium transition-colors"
                >
                  Complete
                </Link>

                <button 
                  className="h-9 w-9 rounded-md flex items-center justify-center text-blue-700 hover:text-blue-900 hover:bg-blue-100"
                  onClick={() => setShowBanner(false)}
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        )}
        
        {/* Dashboard Stats Summary */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {/* Unlocked Deals */}
          <div className="rounded-lg border bg-white text-gray-900 shadow-sm">
            <div className="flex flex-col space-y-1.5 p-6 pb-3">
              <h3 className="text-sm font-medium text-gray-500">Unlocked Deals</h3>
            </div>
            <div className="p-6 pt-0">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-2xl font-bold">{totalUnlockedDeals}</div>
                  <div className="flex items-center">
                    <p className="text-sm text-gray-500">exclusive offers unlocked</p>
                    
                  </div>
                </div>
                <div className="p-2 bg-purple-100 rounded-full">
                  <Gift className="w-5 h-5 text-purple-600" />
                </div>
              </div>

              <Link 
                      to="/dashboard/all-offers"
                      className="ml-2 text-xs text-purple-600 hover:text-purple-800 flex items-center"
                    >
                      View All Offers <ChevronRight className="w-3 h-3" />
                    </Link>
            </div>
          </div>
          
          {/* Earned Points */}
          <div className="rounded-lg border bg-white text-gray-900 shadow-sm">
            <div className="flex flex-col space-y-1.5 p-6 pb-3">
              <h3 className="text-sm font-medium text-gray-500">Earned Points</h3>
            </div>
            <div className="p-6 pt-0">
              <div className="flex items-center justify-between">
                <div>
                  <div className="flex items-baseline">
                    <span className="text-2xl font-bold">{dashboardData?.available_points}</span>
                  </div>
                  <div className="flex items-center">
                    <p className="text-sm text-gray-500">in redeemable rewards</p>
                    
                  </div>
                </div>
                <div className="p-2 bg-green-100 rounded-full">
                  <DollarSign className="w-5 h-5 text-green-600" />
                </div>
              </div>
            </div>
          </div>
          
          {/* Profile Views */}
          {/* <div className="rounded-lg border bg-white text-gray-900 shadow-sm">
            <div className="flex flex-col space-y-1.5 p-6 pb-3">
              <h3 className="text-sm font-medium text-gray-500">Profile Activity</h3>
            </div>
            <div className="p-6 pt-0">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-2xl font-bold">{profileCompleted ? 24 : 0}</div>
                  <p className="text-sm text-gray-500">impressions this week</p>
                </div>
                <div className="p-2 bg-blue-100 rounded-full">
                  <TrendingUp className="w-5 h-5 text-blue-600" />
                </div>
              </div>
            </div>
          </div> */}
        </div>

        {/* Tabs Navigation */}
        <div className="space-y-4">
          {/* <div className="border-b border-gray-200">
            <nav className="flex -mb-px space-x-8">
              {["overview", "offers", "analytics", "profile"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`py-4 px-1 border-b-2 font-medium text-sm ${
                    activeTab === tab
                      ? "border-purple-600 text-purple-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </nav>
          </div> */}
          
          <div className="pt-4">
            {/* Overview Tab */}
            {activeTab === "overview2" && (
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Welcome Card */}
                  <div className="rounded-lg border bg-white shadow-sm md:col-span-2">
                    <div className="flex flex-col space-y-1.5 p-6">
                      <h3 className="text-2xl font-semibold leading-none tracking-tight">Welcome to LeadrPro</h3>
                      <p className="text-sm text-gray-500">
                        Your platform for discovering enterprise software and getting paid for your expertise
                      </p>
                    </div>
                    <div className="p-6 pt-0 space-y-4">
                      <p className="text-gray-600">
                        LeadrPro helps you discover and evaluate the best enterprise software solutions while earning rewards for your time and expertise. Complete the following steps to get started:
                      </p>
                      
                      <div className="space-y-3">
                        {/* Step 1: Complete Profile */}
                        <div className="flex items-center p-3 border rounded-lg bg-gray-50">
                          <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-4 ${profileCompleted ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-500'}`}>
                            <span className="font-semibold">1</span>
                          </div>
                          <div className="flex-1">
                            <p className="font-medium">Complete your professional profile</p>
                            <p className="text-sm text-gray-500">Create your buyer profile to be discovered by relevant vendors</p>
                          </div>
                          <button 
                            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                              profileCompleted 
                                ? "bg-green-100 text-green-700 hover:bg-green-200 hover:text-green-800 border border-green-200" 
                                : "bg-purple-600 hover:bg-purple-700 text-white"
                            }`}
                            onClick={() => setShowProfileDialog(true)}
                          >
                            {profileCompleted ? "Edit" : "Create"}
                          </button>
                        </div>
                        
                        {/* Step 2: Unlock Offers */}
                        <div className="flex items-center p-3 border rounded-lg bg-gray-50">
                          <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-4 ${totalUnlockedDeals > 0 ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-500'}`}>
                            <span className="font-semibold">2</span>
                          </div>
                          <div className="flex-1">
                            <p className="font-medium">Explore exclusive offers</p>
                            <p className="text-sm text-gray-500">Unlock special deals from top software vendors</p>
                          </div>
                          <button 
                            className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-md text-sm font-medium transition-colors"
                            onClick={() => setActiveTab("offers")}
                          >
                            View Offers
                          </button>
                        </div>
                        
                        {/* Step 3: Earn Points */}
                        <div className="flex items-center p-3 border rounded-lg bg-gray-50">
                          <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-4 ${earnedPoints > 0 ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-500'}`}>
                            <span className="font-semibold">3</span>
                          </div>
                          <div className="flex-1">
                            <p className="font-medium">Get paid for your expertise</p>
                            <p className="text-sm text-gray-500">Earn $75 in points for each demo you participate in</p>
                          </div>
                          <button 
                            className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-md text-sm font-medium transition-colors"
                            onClick={() => setShowEarnPointsDialog(true)}
                          >
                            Learn How
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  
          
                </div>
              </div>
            )}
            
            {/* Special Offers Tab */}
            {activeTab === "offers" && (
              profileCompleted ? (
<></>              ) : (
                <div className="rounded-lg border bg-white shadow-sm text-center py-8">
                  <div className="p-6">
                    <div className="mx-auto w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-4">
                      <Unlock className="w-6 h-6 text-gray-400" />
                    </div>
                    <h3 className="text-lg font-medium mb-2">Complete Your Profile to Unlock Offers</h3>
                    <p className="text-gray-500 mb-6">
                      Create your professional profile to access exclusive offers from enterprise software vendors.
                    </p>
                    <button 
                      className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-md text-sm font-medium transition-colors"
                      onClick={() => setShowProfileDialog(true)}
                    >
                      Complete Profile
                    </button>
                  </div>
                </div>
              )
            )}
            
            {/* Analytics Tab */}
            {activeTab === "analytics" && (
              profileCompleted ? (
                <></>
              ) : (
                <div className="rounded-lg border bg-white shadow-sm text-center py-8">
                  <div className="p-6">
                    <div className="mx-auto w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-4">
                      <TrendingUp className="w-6 h-6 text-gray-400" />
                    </div>
                    <h3 className="text-lg font-medium mb-2">Analytics Available After Profile Creation</h3>
                    <p className="text-gray-500 mb-6">
                      Complete your profile to start tracking impressions, visits, and engagement.
                    </p>
                    <button 
                      className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-md text-sm font-medium transition-colors"
                      onClick={() => setShowProfileDialog(true)}
                    >
                      Complete Profile
                    </button>
                  </div>
                </div>
              )
            )}
            
            {/* Profile Tab */}
            {activeTab === "profile" && (
              <></>
            )}
          </div>
        </div>
      </main>

      {/* Profile Dialog */}
      {showProfileDialog && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center">
          <div className="fixed left-[50%] top-[50%] z-50 grid w-full max-w-3xl translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg sm:rounded-lg bg-white">
            <div className="flex flex-col space-y-2 text-center sm:text-left">
              <h2 className="text-lg font-semibold">Complete Your Professional Profile</h2>
              <p className="text-sm text-gray-500">
                Fill in your professional details to unlock exclusive offers and receive relevant vendor requests.
              </p>
            </div>
          
            
            <div className="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2">
              <button 
                className="mt-2 sm:mt-0 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2"
                onClick={() => setShowProfileDialog(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Earn Points Dialog */}
      {showEarnPointsDialog && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center">
          <div className="fixed left-[50%] top-[50%] z-50 grid w-full max-w-md translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg sm:rounded-lg bg-white">
            <div className="flex flex-col space-y-2 text-center sm:text-left">
              <h2 className="flex items-center gap-2 text-lg font-semibold">
                <DollarSign className="w-5 h-5 text-green-500" />
                Get Paid for Your Expertise
              </h2>
              <p className="text-sm text-gray-500">
                Turn your expertise into rewards with our paid demo program
              </p>
            </div>
            
            <div className="space-y-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-semibold mb-2">How it works:</h4>
                <ol className="list-decimal pl-5 space-y-2">
                  <li>Complete your professional profile</li>
                  <li>Vendors request to meet with you</li>
                  <li>Participate in a 30-45 minute demo</li>
                  <li>Earn $75 in points for each completed demo</li>
                  <li>Redeem points for gift cards or cash rewards</li>
                </ol>
              </div>
              
              <div className="bg-green-50 p-4 rounded-lg border border-green-100">
                <h4 className="font-semibold text-green-800 mb-2">Your potential earnings:</h4>
                <div className="flex justify-between items-center">
                  <span>1 demo per month</span>
                  <span className="font-bold">$900/year</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>2 demos per month</span>
                  <span className="font-bold">$1,800/year</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>4 demos per month</span>
                  <span className="font-bold">$3,600/year</span>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2">
              <button 
                onClick={() => {
                  setShowEarnPointsDialog(false);
                  if (!profileCompleted) {
                    setShowProfileDialog(true);
                  }
                }}
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-purple-600 hover:bg-purple-700 h-10 px-4 py-2 text-white"
              >
                {profileCompleted ? "Got it" : "Complete Profile to Start"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default BuyerHome;
